<template lang="pug">
  div
    order-step(:current-step="2")
    h2
      | Übersicht
    order-summary(
      editable
      :order-summary="orderSummary"
      )
    div
    div.card-footer.text-right(
      v-if="orderSummary"
      :class="{ 'text-muted': !canGoNext }")
      template(v-if="formHasError")
        span.mb-2.d-flex.flex-wrap.justify-content-end
          | Bitte korrigieren Sie die Bestellung
      template(v-else)
        span.mb-2.d-flex.flex-wrap.justify-content-end
          span.no-wrap(v-if="customer && customer.studentProducts === 1") Preis:&nbsp;
            strong.no-wrap {{ orderSummary.totalPriceB2c }}
          span.no-wrap(v-else) Preis:&nbsp;
            strong.no-wrap {{ orderSummary.totalPriceB2b }}
          span.mx-2 &middot;
          span.no-wrap Menge:&nbsp;
            strong.no-wrap {{ orderSummary.totalQuantity }}
          span.mx-2 &middot;
          span.no-wrap {{ discountLabel }}:&nbsp;
            strong.no-wrap {{ orderSummary.onlineDiscount }}
          span.mx-2 &middot;
          span.no-wrap Versand:&nbsp;
            strong.no-wrap {{ orderSummary.shippingCosts }}
          span.mx-2 &middot;
          span.no-wrap {{ orderSummary.vatPercentage }}:&nbsp;
            strong.no-wrap {{ orderSummary.vat }}
          span.mx-2 &middot;
          span.no-wrap Gesamt:&nbsp;
            strong.no-wrap {{ orderSummary.totalPrice }}
        template(v-if="hasNewEdits")
          div.spinner-border.spinner-border-md.text-success.mr-3
      button.mr-2.btn.btn-secondary(
        type="button"
        @click="goBack"
        )
        | Zurück
      button.btn.btn-primary.btn-lg(
        type="button"
        @click="showDeliveryAddress"
        :disabled="!canGoNext"
        )
        | Weiter
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import OrderStep from '@/components/orderForm/orderStep'
import OrderSummary from '@/components/orderForm/orderSummary'

export default {
  name: 'ViewOrder',
  components: {
    OrderStep,
    OrderSummary
  },
  data: () => ({
    hasNewEdits: false
  }),
  computed: {
    ...mapState('orderForm', [
      'orderSummary',
      'productQuantities'
    ]),
    ...mapState({
      updatingOrderSummary: state => !!state.orderFormService.loadingIndicators.getOrderSummary
    }),
    ...mapGetters('orderForm', [
      'formHasError'
    ]),
    ...mapGetters('authentication', ['customer']),
    discountLabel () {
      // Check if customer is a student
      if (this.customer && this.customer.studentProducts === 1) {
        return 'Schüler-Rabatt 10%'
      }
      return 'Online-Rabatt 3%'
    },
    canGoNext () {
      return !this.updatingOrderSummary && !this.hasNewEdits && !this.formHasError
    }
  },
  watch: {
    productQuantities: {
      handler () {
        this.hasNewEdits = true
      },
      deep: true
    },
    updatingOrderSummary (newVal) {
      if (!newVal) {
        this.hasNewEdits = false
      }
    }
  },
  methods: {
    ...mapActions('ui', [
      'goBack',
      'showDeliveryAddress'
    ])
  }
}
</script>
